import { render, staticRenderFns } from "./CompanyDetailsInfoForm.vue?vue&type=template&id=9d8a03c8&scoped=true&"
import script from "./CompanyDetailsInfoForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CompanyDetailsInfoForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CompanyDetailsInfoForm.vue?vue&type=style&index=0&id=9d8a03c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8a03c8",
  null
  
)

export default component.exports